import { Box, Button, IconButton, Typography, useMediaQuery, useTheme } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import bgImage from '../../../assets/background/bg-booking-meeting-classroom.jpg';
import StateComponents from '../../../components/state-component/StateComponents';
import { icons } from '../../../assets/icons/icons';
import { debouncedApiCall } from '../../../utils/app.utils';
import { room_meeting_type_data } from '../../../constants/enum';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import { booking_meeting_room_status } from './enum';
import TableCustom from '../../../components/table/tableCustom';
import OptionsButtonCustom from '../../../components/option-button/OptionsButtonCustom';
import TableRowCommon from '../../../components/table/TableRowCommon';
import { BookingMeetingRoomApi, frontBookingMeetingRoomListType } from '../../../api/booking-meeting-room/booking-meeting-room.api';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { routeName } from '../../../routes/routeName';
import { alertActive, alertError, alertSuccess } from '../../../components/alert/swal';
import StatusCustom from '../../../components/status/statusCustom';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import BookingCalendarLegacy from './element/CalendarActivity';

type Props = {
    is_personal?: boolean;
}

const ClassroomMeetingBooking: React.FC<Props> = ({ is_personal }: Props) => {

    const navigate = useNavigate();
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('md'));
    const dispatch = useDispatch();

    const [search, set_search] = useState<string>("");
    const [room_meeting_type, set_room_meeting_type] = useState<any>(null);
    const [start_date, set_start_date] = useState<string>("");
    const [end_date, set_end_date] = useState<string>("");
    const [booking_status, set_booking_status] = useState<any>(null);


    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC");
    const [data, setData] = useState<any[]>([]);

    const [active_tabs, set_active_tabs] = useState<"LIST" | "CALENDAR">("LIST")

    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "subject_no", width: 60, sortable: false, disablePadding: false, align: 'center', label: "ประเภทห้อง"
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "left", label: "ชื่อห้อง"
        },
        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: "ช่วงวันที่จอง"
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: "ช่วงเวลา"
        },
        {
            id: "a", disablePadding: false, align: "center", width: 141, label: "วันที่ดำเนินการ"
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 200, class: matches && data.length > 0, label: "สถานะ"
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            meeting_room_name,
            meeting_room_start_date,
            meeting_room_end_date,
            meeting_start_time,
            meeting_end_time,
            created_date,
            id_meeting_room,
            meeting_room_status,
            room_meeting_type
        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: room_meeting_type || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: meeting_room_name || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (meeting_room_start_date && meeting_room_end_date) ?
                        `${moment(meeting_room_start_date).format("DD/MM/YYYY")} - ${moment(meeting_room_end_date).format("DD/MM/YYYY")}`
                        : "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: (meeting_start_time && meeting_end_time) ? `${meeting_start_time} - ${meeting_end_time}` : '-'
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: created_date ? moment(created_date).format("DD/MM/YYYY") : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-between gap-4 items-center'>
                        <div>
                            <StatusCustom
                                disableMaxWidth
                                sx={{ width: 'fit-content', px: 2.5 }}
                                text={booking_meeting_room_status?.find((x) => x.value == meeting_room_status)?.label || ""}
                                type={booking_meeting_room_status?.find((x) => x.value == meeting_room_status)?.label || ""}
                            />
                        </div>
                        <div>
                            <OptionsButtonCustom
                                enableEdit
                                enableView
                                enableDelete
                                onViewClick={() => {
                                    if (is_personal) {
                                        navigate(routeName.cms.BookingRoomView.replace(":id", id_meeting_room))
                                    } else {
                                        navigate(routeName.public.classroom_meeting_booking_view.replace(":id", id_meeting_room))
                                    }
                                }}
                                onEditClick={() => {
                                    if (is_personal) {
                                        navigate(routeName.cms.BookingRoomUpdate.replace(":id", id_meeting_room))
                                    } else {
                                        navigate(routeName.public.classroom_meeting_booking_detail.replace(":id", id_meeting_room))
                                    }
                                }}
                                onDeleteClick={() => {
                                    id_meeting_room && handleDeleteList(id_meeting_room)
                                }}
                            />
                        </div>
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    const handleDeleteList = (id_meeting_room: number) => {
        alertActive("ลบรายการ", "ต้องการลบรายการ หรือไม่?", undefined, undefined, async () => {
            dispatch(setLoading());
            await BookingMeetingRoomApi.deleteBookingMeetingRoom(id_meeting_room).then((res) => {
                if (res.status < 300) {
                    alertSuccess("ลบรายการ", "ลบรายการ เรียบร้อยแล้ว")
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError("ลบรายการ", err?.response?.data?.message || "ลบรายการ ไม่สำเร็จ")
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    const handleGetData = useCallback(async () => {
        let query: frontBookingMeetingRoomListType = {
            page: page,
            limit: pageLimit
        }
        if (start_date) query.sdate = moment(start_date).format("YYYY-MM-DD");
        if (end_date) query.edate = moment(end_date).format("YYYY-MM-DD");
        if (booking_status) query.meeting_room_status = booking_status?.value;
        if (room_meeting_type) query.room_meeting_type = room_meeting_type?.value
        if (search) query.keyword = search
        dispatch(setLoading());
        await BookingMeetingRoomApi.frontBookingMeetingRoomList(query).then((res) => {
            if (res.status < 300) {
                const response = res.data?.data?.items || [];
                setData(response);
                setTotalItems(res.data?.data?.meta?.totalItems || 0);
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, search, start_date, end_date, booking_status, room_meeting_type])

    useEffect(() => {
        handleGetData();
    }, [handleGetData])


    return (
        <>
            {is_personal ? <Box className="flex justify-between items-center gap-4">
                <Box></Box>
                <Box className='flex justify-center items-center flex-col gap-4'>
                    <Typography variant='h3'>
                        จองห้องเรียน/จองห้องประชุม
                    </Typography>
                    <Typography>
                        กรุณาเลือกรายการที่ท่านต้องการ
                    </Typography>
                </Box>
                <Box className="flex items-center justify-end gap-2">
                    {is_personal && (
                        <>
                            <IconButton onClick={() => set_active_tabs('LIST')}>
                                <PlaylistAddCheckIcon sx={{ color: active_tabs === 'LIST' ? 'black' : 'rgba(0,0,0,0.3)' }} />
                            </IconButton>
                            <div>|</div>
                            <IconButton onClick={() => set_active_tabs('CALENDAR')}>
                                <CalendarMonthIcon sx={{ color: active_tabs === 'CALENDAR' ? 'black' : 'rgba(0,0,0,0.3)' }} />
                            </IconButton>
                        </>
                    )}
                </Box>
            </Box> : (
                <Box sx={{
                    position: 'relative',
                    backgroundImage: `url(${bgImage})`,
                    backgroundPosition: 'center',
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                }} className="w-full min-h-[250px] flex justify-center items-center">
                    <Box
                        sx={{
                            position: "absolute",
                            inset: 0,
                            backgroundColor: "rgba(0, 0, 0, 0.5)",
                            zIndex: 1,
                        }}
                    />

                    <Box className='flex flex-col gap-4 z-10' >
                        <Typography className="text-white" variant='h1' textAlign={"center"}>
                            ระบบจองห้องเรียนและห้องประชุม
                        </Typography>
                        <Typography sx={{ color: 'white' }} textAlign={"center"}>
                            หากท่านมีความประสงค์ต้องการจองห้องเรียนหรือห้องประชุม ของทางวิทยาลัยพุทธศาสตร์นานาชาติ ท่านสามารถทำรายการได้ในหน้านี้
                        </Typography>
                    </Box>
                </Box>
            )}
            {active_tabs === 'LIST' ? (
                <Box className="w-full min-h-screen flex flex-col">


                    <Box className="flex px-4 md:px-10 py-10">
                        <Box className="flex-1">
                            <StateComponents
                                otherProps={{ spacing: 2 }}
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12,
                                            md: 3
                                        },
                                        fieldProps: {
                                            onChange: (e) => debouncedApiCall({ searchItem: e.target.value, setItem: set_search }),
                                            startAdornment: <Box mr={1}><icons.SearchNormal /></Box>,
                                            placeholder: 'ค้นหาชื่อห้อง'
                                        }
                                    },
                                    {
                                        seq: 2,
                                        type: "AUTO-COMPLETE",
                                        gridProps: {
                                            xs: 12,
                                            md: 2
                                        },
                                        fieldProps: {
                                            getOptionLabel: (op) => op?.label || "",
                                            labelId: "room_meeting_type_data",
                                            onChange: (_, val) => set_room_meeting_type(val ?? null),
                                            options: room_meeting_type_data,
                                            value: room_meeting_type,
                                            placeholder: 'ทุกประเภทห้อง',
                                        }
                                    },
                                    {
                                        seq: 3,
                                        type: "DATE_RANGE2",
                                        gridProps: {
                                            xs: 12,
                                            md: 2
                                        },
                                        fieldProps: {
                                            handleChange: (st, end) => {
                                                set_start_date(st ?? "");
                                                set_end_date(end ?? "");
                                            },
                                            value: {
                                                start_date,
                                                end_date
                                            },
                                            placeholder: 'ช่วงวันที่จอง',
                                        }
                                    },
                                    {
                                        seq: 4,
                                        type: "AUTO-COMPLETE",
                                        gridProps: {
                                            xs: 12,
                                            md: 2
                                        },
                                        fieldProps: {
                                            getOptionLabel: (op) => op?.label || "",
                                            labelId: "status",
                                            onChange: (_, val) => set_booking_status(val ?? null),
                                            options: booking_meeting_room_status,
                                            value: booking_status,
                                            placeholder: 'สถานะ',
                                        }
                                    },
                                ]}
                            />
                        </Box>
                        <Box>
                            <Button
                                startIcon={<AttachEmailIcon />}
                                color='success'
                                variant='contained'
                                onClick={() => {
                                    if (is_personal) {
                                        navigate(routeName.cms.BookingRoomCreate)
                                    } else {
                                        navigate(routeName.public.classroom_meeting_booking_create)
                                    }
                                }}
                            >
                                ทำเรื่องขอจอง
                            </Button>
                        </Box>
                    </Box>


                    <Box className='w-full mt-4 px-4 md:px-10'>
                        <TableCustom
                            tableMinWidth={1440}
                            tableFixedWidth
                            customScroll
                            page={page}
                            pageLimit={pageLimit}
                            sortBy={sortBy}
                            sortType={sortType}
                            headCells={headCells}
                            rowCount={totalItems}
                            rowsData={data?.map((data: any, i: any) => {
                                return renderData(data, i)
                            })}
                            onSort={handleRequestSort}
                            setPageLimit={(value: number) => setPageLimit(value)}
                            setPage={(value: number) => setPage(value)}
                        />
                    </Box>


                </Box>
            ) : (
                <>
                    <BookingCalendarLegacy
                        
                    />
                </>
            )}
        </>
    )
}

export default ClassroomMeetingBooking